import { Component } from '@angular/core';

@Component({
  selector: 'app-guest-layout',
  template: '<router-outlet></router-outlet>',
  standalone: false
})
export class GuestLayoutComponent {}
